import l from '../libs/lang';
import CallReport from './CallReport';

/**
 *
 */
export default class Duration extends CallReport {
    /**
     *
     * @param {object} session
     * @param {object} component
     */
    constructor(session, component) {
        super(
            session,
            component,
            [
                'total',
            ],
            'duration',
            'duration'
        );
        this.logarithmic = false;
    }

    /**
     *
     */
    // eslint-disable-next-line class-methods-use-this
    set headers(v) {
        console.log(`${v} is not a proper header value`);
    }

    /**
     *
     */
    get headers() {
        const headers = {};
        Object.keys(this.fields).map(
            (x) => {
                headers[x] = this.fields[x].translation;
                return x;
            }
        );
        const group_by = this.filters.group_by.charAt(0).toUpperCase()
            + this.filters.group_by
                .slice(1)
                .split('_')
                .join(' ')
                .split('-')
                .join(' ');
        headers[this.filters.group_by] = `${l.t(`reports.${this.filters.group_by}`, group_by)}`;

        return headers;
    }

    /**
     *
     * @param {Array} itms
     * @returns
     */
    async prepare_items(itms) {
        const items = itms;
        const { group_by } = this.filters;
        if (!group_by) {
            throw new Error(l.t(
                'reports.please-provide-group-by',
                'Please provide group by parameter.'
            ));
        }
        items.sort((a, b) => (a[group_by] > b[group_by] ? 1 : -1));
        const ranges = [
            { display: '0 sec', min: 0, max: 0 },
            { display: '1-6 sec', min: 1, max: 6 },
            { display: '7-29 sec', min: 7, max: 29 },
            { display: '30-59 sec', min: 30, max: 59 },
            { display: '1-2 min', min: 60, max: 119 },
            { display: '2-3 min', min: 120, max: 179 },
            { display: '3-5 min', min: 180, max: 299 },
            { display: '5-10 min', min: 300, max: 599 },
            { display: '10-30 min', min: 600, max: 1799 },
            { display: '30-60 min', min: 1800, max: 3599 },
            { display: '1 hour +', min: 3600, max: Infinity },
        ];
        const getDuration = (duration) => {
            if (duration === 0) return '0:00:00';
            let hours = 0;
            if (!duration || duration === Infinity || duration === -Infinity) return '~';
            let min = Math.floor(duration / 60);
            if (min >= 60) {
                hours = Math.floor(min / 60);
                min %= 60;
            }
            const sec = (Math.round(duration % 60));
            return `${hours}:${min < 10 ? `0${min}` : min}:${sec < 10 ? '0' : ''}${sec}`;
        };

        const buildDuration = (min, max) => {
            if (max === Infinity) return `${getDuration(min)} +`;
            // if (min === max) return getDuration(min);
            return `${getDuration(min)} - ${getDuration(max)}`;
        };

        const items_in_ranges = ranges.map(({ min, max, display }) => {
            const matching = items.filter((item) => item.duration >= min && item.duration <= max);
            const total = matching.reduce((sum, i) => sum + (i.total || 0), 0);
            return { range: display, duration: buildDuration(min, max), total };
        });

        return items_in_ranges;
    }
}
